import PageHeader from 'components/pageHeader/PageHeader';
import { Trans } from 'react-i18next';
import { PropertyBusinessType } from 'models/Properties';
import PropertyEditPermissionInfo from '../common/PropertyEditPermissionInfo';
import PermissionsAwareFieldset from '../common/PermissionsAwareFieldset';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import { SectionContainer } from './PropertySettingsFeesAndPoliciesTab.styles';
import CancellationPolicy from './sections/cancellationPolicy/CancellationPolicy';
import PropertyExpectations from './sections/propertyExpectations/PropertyExpectations';
import HouseRules from './sections/houseRules/HouseRules';
import PropertyFeesAndTaxes from './sections/propertyFeesAndTaxes/PropertyFeesAndTaxes';
import RentalConditions from './sections/rentalConditions/RentalConditions';

const PropertySettingsFeesAndPoliciesTab = () => {
  const { property } = usePropertySettingsInitData();

  const showCancellationPolicy =
    property?.businessType !== PropertyBusinessType.UNIT &&
    property?.businessType !== PropertyBusinessType.HOTEL;

  const showRentalConditions =
    property?.businessType !== PropertyBusinessType.HOTEL;

  return (
    <>
      <PageHeader
        title={
          <Trans
            i18nKey="pageProperty.feesTaxesAndPolicies.pageTitle"
            values={{ propertyName: property?.name }}
            components={{ 1: <span className="green" /> }}
          />
        }
        noDivider
      />
      <PropertyEditPermissionInfo />
      <PermissionsAwareFieldset>
        <SectionContainer>
          <PropertyFeesAndTaxes
            currency={property?.pricing?.currency ?? undefined}
          />
          <HouseRules />
          <PropertyExpectations />
          {showCancellationPolicy && <CancellationPolicy />}
          {showRentalConditions && <RentalConditions />}
        </SectionContainer>
      </PermissionsAwareFieldset>
    </>
  );
};

export default PropertySettingsFeesAndPoliciesTab;
